import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Careers } from '/screens/';

export default function CareersPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics jobs, logisitcs careers, chciago jobs, freight tech jobs, SaaS sales, SaaS jobs, SasS career, freight logistics"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Freight Tech Careers & Logistics Technology Jobs | Loadsmart"
        description="Looking for a logistics job or a career in freight tech? Explore career opportunities at Loadsmart and our benefits and culture. "
        canonical="https://loadsmart.com/careers/"
        openGraph={{
          url: 'https://loadsmart.com/careers/',
        }}
      />
      <Careers />
    </>
  );
}
